module.exports = __webpack_public_path__ + "static/forecast/weather/nightlightsnow-c7b6c8efb0fc7a3a028e28730e7d0c5e.svg";